import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoStableIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_stable"}/>
}
